var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPricetag(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    color: "#53002E",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pricetag_svg__clip0_9179_1673)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.707 3.416c.577.375 1.143.758 1.58 1.28l1.251 1.47c.629 1.049.493 2.314.566 3.586.048.79-.25 1.566-.805 2.133-1.338 1.368-2.761 2.706-3.912 4.302l-2.152 2.276c-.864 1.232-2.132 1.57-3.232.61-2.132-1.856-4.236-3.757-6.111-5.795.055-1.724.923-2.963 1.938-4.1 1.335-1.493 2.905-2.82 3.949-4.515 1.085-1.758 2.614-1.953 4.365-1.894.32.011 1.07.118 1.39.118M8.904 5.817c-.338 2.979-.405 5.976-.64 8.962"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.314 5.818l.441-1.765c.133-.537.206-1.089.166-1.637-.055-.805-.328-1.504-1.302-1.864-.963-.353-1.765-.228-2.423.768-.728 1.107-.831 2.317-.901 3.542v.01c-.037.703 1.007.787 1.081.089.129-1.21-.143-2.354 1.074-3.214.217-.154.452-.224.702-.136.298.107.644.636.728.978.066.28-.048 1.364-.412 2.078l.842 1.15h.004zM6.279 11.392H6.26a1.044 1.044 0 01-1.055-.886c-.162-1.033.17-1.703.985-1.945.666-.195 1.276.04 1.273.934L7.26 10.55c-.091.478-.5.824-.985.838l.004.004z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.071 8.855c-1.684 2.368-4.89 5.133-6.6 7.497L9.386 17.42c-1.066.853-1.055 1.224-2.158.264-1.64-1.419-3.541-3.133-5.023-4.692-.306-.32-.592-1.103-1.037-1.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.845 10.65s0 .021.008.032c.235 1.291 2.037 1.49 2.625.32.004-.01.011-.018.015-.03.334-.668.088-1.5-.581-1.834l-.033-.018c-.42-.199-.916-.14-1.302.117l-.129.089c-.437.29-.684.808-.595 1.323h-.008z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pricetag_svg__clip0_9179_1673"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.524)",
    d: "M0 0h16.952v20H0z"
  })))));
}
export default SvgPricetag;